/**
 * @author Abbas Rattansi
 */
import { View } from 'okta';
export default View.extend({
  template:
    '<p class="torii-banner-content">Use the <a href="https://developer.okta.com/login">OIN Wizard</a> ' +
    'to submit an SSO or SCIM integration. ' +
    'See <a href="https://developer.okta.com/docs/guides/submit-oin-app/openidconnect/main/">Submit an ' +
    'integration with the OIN Wizard</a> for instructions.</p>',
});
